import SEOLandingPage from "@/components/SEOLandingPage";

const UGCAgenturHamburg = () => (
  <SEOLandingPage
    lang="de"
    title="UGC Agentur Hamburg | AI UGC Creator Hamburg | Fuel72"
    metaDescription="UGC Agentur Hamburg: Professionelle AI UGC Videos für Hamburger Unternehmen. 72 Stunden Lieferung."
    keywords="ugc agentur hamburg, ugc creator hamburg, ugc hamburg, ai ugc hamburg"
    canonical="https://www.fuel72.com/ugc-agentur-hamburg"
    hreflang={[{ lang: "de", href: "https://www.fuel72.com/ugc-agentur-hamburg" }]}
    heroTitle="UGC Agentur"
    heroHighlight="Hamburg"
    heroDescription="Professionelle AI UGC Videos für Hamburger Unternehmen. 72 Stunden Lieferung."
    sections={[
      { title: "UGC Agentur Hamburg", content: "Hamburg ist Deutschlands Medienhauptstadt. Fuel72 liefert UGC Videos für den anspruchsvollen Hamburger Markt.", items: ["UGC Videos für Hamburger Unternehmen", "KI-generiert — keine Creator-Suche", "72 Stunden Lieferung", "Ab 49€ pro Video"] },
      { title: "UGC für Hamburger Branchen", content: "Von HafenCity bis Altona.", grid: [{ icon: "⚓", title: "Maritime Wirtschaft", description: "Hamburgs Hafen-Szene." }, { icon: "🎬", title: "Medien", description: "Deutschlands Medien-Hauptstadt." }, { icon: "🍽️", title: "Gastronomie", description: "Restaurants an der Elbe." }, { icon: "🛍️", title: "E-Commerce", description: "Online-Händler und D2C." }] },
    ]}
    faqs={[{ question: "Gibt es eine UGC Agentur in Hamburg?", answer: "Ja! Fuel72 bedient Hamburger Unternehmen mit 72-Stunden Lieferung." }]}
    relatedPages={[{ href: "/ugc-agentur", label: "UGC Agentur Deutschland" }, { href: "/ugc-agentur-berlin", label: "Berlin" }, { href: "/ugc-kaufen", label: "UGC kaufen" }]}
  />
);

export default UGCAgenturHamburg;
